import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';

import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { sortPropertyListByName } from '../../../../../../helpers/Utils';
import {
    gAPI_Property_List_By_Group,
    postAPI_Create_A_Message,
    API_SpaceStandalonePage_Integration,
} from '../../../../../../constants/APIs';
import short from 'short-uuid';
import Axios from 'axios';
import { Switch } from 'react-router-dom';
import Validation from '../../../../../../components/Validation';
const GreetingCode1 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode1 = `integration-${short.generate()}-eyeCatcher`;
const GreetingCode2 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode2 = `integration-${short.generate()}-eyeCatcher`;

let arr = [];
export default function AddSpaceStandAlonePageIntegration({ visible, toggle, LoadIntegrations }) {
    const [property, setProperty] = useState([]);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [inputData, setInputData] = useState({
        GroupId: getGroupID(),
        Name: '',
        Level: 'Group',
        Properties: property,
        SessionTimeoutInSeconds: 600,
        BaseUrl: 'https://www.bookmebob.com',
        HomePageRoute: '/',
        DefaultLanguage: 'en-US',
        DefaultRuleDescription: 'Default',
        IsFooterHide: false,
        PageSettings: {
            layoutType: 0, title: '', subtitle: '', scrollDirection: 1, arrowType: 0, arrowSize: 40,
            colours: {
                title: '', subtitle: '', arrow: 'black', primaryColor: '#E31B78',
                buttonColor: '#033DA5',
                redeemBar: '#FA8DAB',
                redeemButton: '#F5D2E3',
                buttonTextColor: 'white',
                redeemTextColor: 'black',
                shoppingBar: '#ED187B',
                shoppingBarText: 'white'
            }, icon: 'https://via.placeholder.com/150/'
        }
    });

    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
        })
            .then((res) => {
                setProperty([...res.data]);
                let lst = [];
                res.data.map((m) =>
                    lst.push(m.id));
                setInputData({ ...inputData, Properties: lst });
            })
            .catch((err) => console.error(err));
    }, []);

    const handleChange = (e) => {
        let page = inputData.PageSettings;
        switch (e.target.name) {
            case 'title':
                page.title = e.target.value;
                break;
            case 'subtitle':
                page.subtitle = e.target.value;
                break;
        }
        setInputData({ ...inputData, PageSettings: page });
        e.persist();
        setInputData({ ...inputData, [e.target.name]: e.target.value });
    };


    const handleCheckChange = (e) => {
        let filterList = [];
        if (inputData.Properties.filter((p) => p === e.target.value).length > 0) {
            filterList = inputData.Properties.filter(f => f !== e.target.value);
        }
        else {
            filterList = inputData.Properties;
            filterList.push(property.filter((p) => p.id === e.target.value)[0].id);
        }
        setInputData({ ...inputData, Properties: filterList });
    };

    const handleSave = async () => {
        /**  When creating a response for a integration, don't need pass a property id*/
        AxiosAPI({
            method: 'post',
            url: `${API_SpaceStandalonePage_Integration}`,
            data: inputData,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                toggle();
                setTimeout(() => {
                    toggle();
                    try {
                        LoadIntegrations();
                    } catch {
                        window.location.reload()
                    }
                }, 300);
            }
        });
    };
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle}>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            <div className="text-center">
                                <h6>Connect Space Standalone Page to your website</h6>
                                <Separator className="mb-3" />

                                <Form>
                                    <FormGroup>
                                        <Input
                                            type="text"
                                            name="title"
                                            onChange={handleChange}
                                            placeholder="Enter your title"
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Input
                                            type="text"
                                            name="subtitle"
                                            onChange={handleChange}
                                            placeholder="Enter your subtitle"
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <div className='my-2 text-center'><h3>Select your business name</h3> </div>
                                        <div style={{ padding: '0 20%' }}>
                                            {sortPropertyListByName(property).map((p, index) => {
                                                return (
                                                    <CustomInput
                                                        key={p.id}
                                                        type="checkbox"
                                                        id={index}
                                                        value={p.id}
                                                        label={p.name}
                                                        checked={inputData.Properties.filter((f) => p.id === f).length > 0 ? true : false}
                                                        onChange={handleCheckChange}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </FormGroup>
                                </Form>
                                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                    <Button className="text-white" color="primary" size="xs" onClick={handleSave}>
                                        Get Started
                                    </Button>
                                    <Button size="xs" color="dark" outline onClick={toggle}>
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
}
